import { Button, Form, Input, Select, Space } from "antd";
import { useEffect } from "react";
import SelectDropdownLgIcon from "../../../assets/icons/SelectDropdownLgIcon";
import { useGetDepartmentsQuery } from "../../../features/department/departmentApi";
import {
  useAddDesignationMutation,
  useGetDesignationDetailsQuery,
  useUpdateDesignationMutation,
} from "../../../features/designation/designationApi";
import useError from "../../../hooks/useError";
import { toast } from "../../../lib/toast";
import { ModalComponentProps } from "../../../types";
import { selectArrayOption, selectSearchOption } from "../../../utils/utils";
import CustomModal from "../../ui/CustomModal";
import Loader from "../../ui/Loader";

export default function ManageDesignation({
  handleClose,
  type,
  data,
  ...rest
}: ModalComponentProps<string>) {
  const [form] = Form.useForm();
  const {
    isError: isDepartmentError,
    error: departmentError,
    data: departmentData,
  } = useGetDepartmentsQuery({ params: { skip: 0, limit: 0 } });
  const {
    isLoading: isDesignationLoading,
    isError: isDesignationDetailsError,
    error: designationDetailsError,
    data: designationDetails,
  } = useGetDesignationDetailsQuery(data || "", {
    skip: !data && type !== "UPDATE",
  });
  const [addDesignation, { isLoading, isError, isSuccess, error }] =
    useAddDesignationMutation();
  const [
    updateDesignation,
    {
      isLoading: isUpdateLoading,
      isError: isUpdateError,
      isSuccess: isUpdateSuccess,
      error: updateError,
    },
  ] = useUpdateDesignationMutation();

  // error toast message
  useError(
    isDesignationDetailsError,
    designationDetailsError,
    "Get designation fail"
  );
  useError(isDepartmentError, departmentError, "Get department data fail");
  useError(isError, error, "Designation added fail");
  useError(isUpdateError, updateError, "Designation updated fail");

  const onFinish = (values: unknown) => {
    if (type === "UPDATE" && data) {
      return updateDesignation({ body: values, id: data });
    }

    return addDesignation(values);
  };

  useEffect(() => {
    if (
      Object.keys(designationDetails?.data?.role || {}) &&
      type === "UPDATE"
    ) {
      const designation = designationDetails?.data?.role;

      form.setFieldsValue({
        name: designation?.name,
        business_department_id: designation?.business_department_id,
      });
    }
  }, [form, designationDetails?.data?.role, type]);

  // success toast message
  useEffect(() => {
    if (isSuccess) {
      toast("success", "Designation added successfully");
      return handleClose();
    }
    if (isUpdateSuccess) {
      toast("success", "Designation updated successfully");
      return handleClose();
    }
  }, [handleClose, isSuccess, isUpdateSuccess]);

  return (
    <CustomModal
      title={`${type === "UPDATE" ? "Update" : "Add New"} Designation`}
      {...rest}
      handleClose={handleClose}
      width={460}
      footer={null}
    >
      <Form
        className="custom-form"
        layout="vertical"
        requiredMark="optional"
        size="large"
        onFinish={onFinish}
        form={form}
      >
        {isDesignationLoading ? (
          <Loader />
        ) : (
          <>
            <Form.Item
              name="business_department_id"
              label="Department"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please select department",
                },
              ]}
            >
              <Select
                placeholder="Select"
                size="large"
                allowClear
                showSearch
                filterOption={selectSearchOption}
                options={selectArrayOption(
                  departmentData?.data?.departments || [],
                  "name",
                  "id"
                )}
                suffixIcon={<SelectDropdownLgIcon />}
              />
            </Form.Item>
            <Form.Item
              name="name"
              label="Designation Name"
              className="mb-4"
              rules={[
                {
                  required: true,
                  message: "Please enter name",
                },
              ]}
            >
              <Input size="large" placeholder="Enter name" />
            </Form.Item>
            {/* <Form.Item name="abbreviation" label="Abbreviation" className="mb-4">
          <Input size="large" placeholder="Ex: HRM" />
        </Form.Item> */}
          </>
        )}

        <Space className="w-full mt-2" size={12}>
          <Button
            className="normal-dark-button modal-button"
            onClick={handleClose}
            size="middle"
            disabled={isLoading || isUpdateLoading}
          >
            Cancel
          </Button>
          <Button
            className="modal-button"
            type="primary"
            htmlType="submit"
            size="middle"
            loading={isLoading || isUpdateLoading}
            disabled={isDesignationLoading}
          >
            {type === "UPDATE" ? "Update" : "Save"}
          </Button>
        </Space>
      </Form>
    </CustomModal>
  );
}
